import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralWrapper = styled.div`
  color: ${({ theme }) => theme.neutral.black};
  display: grid;
  grid-template-columns: 50px 2fr;
  background: ${({ theme }) => theme.neutral.white};
  padding: 1em;
  font-size: 14px;
  align-items: center;
  border-radius: 5px;
  margin: 10px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 8px ${({ theme }) => theme.shadows.medium};
    transition: 0.5s;
    transform: translateY(-3px);
  }
`;
